import { registerPlugin } from '@capacitor/core';

export interface ImmersiveModePlugin {
  enable(): Promise<void>;
  disable(): Promise<void>;
}

export const ImmersiveMode = registerPlugin<ImmersiveModePlugin>('ImmersiveMode');
